export const API_BASE_URL = "http://localhost:8080";
export const GOOGLE_CLIENT_ID = ""; // Insert your Google OAuth Client ID here. If empty, the app runs in developer-mock mode for Google Sign-in.
